import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { Warehouses, Warehouse, CreateWarehouse, UpdateWarehouse } from "./pages";

export const WarehousesRouter = [
  <Route
    path="/warehouses"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Warehouses />
      </ProtectedRoute>
    }
  />,

  <Route path="/warehouse">
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateWarehouse />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Warehouse />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateWarehouse />
        </ProtectedRoute>
      }
    />
  </Route>,
];
